import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is a cloud-managed services provider?",
    answer: `<p>An MCSP is a company that provides managed cloud services.
    These managed cloud providers may be directly connected to
    the cloud resources you are using or to a third-party
    provider. Managed cloud providers often give subscriptions
    for a variety of services.</p>`,
  },
  {
    question: "What is a cloud management company?",
    answer: `<p>Cloud management refers to the structured management of
    cloud computing products and services. It refers to the
    methods, tactics, rules, and technologies used to manage and
    regulate public, private, hybrid, and multi-cloud
    environments.</p>`,
  },
  {
    question: "What are cloud services companies?",
    answer: `<p> An IT business that provides scalable, on-demand computing
    resources, including processing power, data storage, and
    applications, over the Internet is known as a cloud service
    provider (CSP).</p>`,
  },
  {
    question: "Why use cloud-managed services?",
    answer: `<p> Backing up the hosted systems is part of what managed cloud
    service providers offer. Disaster recovery as a service
    (DRaaS) is a backup service that protects your operating
    systems, information, files, applications, and settings. You
    might be able to use it, as well.</p>`,
  },
  {
    question: " What are end-to-end managed cloud services?",
    answer: `<p> Managed Cloud Services encompasses all of the services
    needed to successfully manage the cloud ecosystem, from its
    inception to day-to-day operations. These services cover
    cloud resource optimization, maintenance, security
    round-the-clock, and planning.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Managed Cloud Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
